import { motion } from "framer-motion";

const MILESTONES = [
  {
    year: "Age 4½",
    title: "The Near-Death Experience",
    text: "Locked inside an unplugged freezer in her parents' garage, four-and-a-half-year-old Susan crossed into the spirit world — held, she says, by angels and a Divine presence. Her mother heard a sudden, certain whisper: 'Your baby is in the freezer.' Susan was saved — and from that moment on, she could feel, see, hear, and communicate with spirit.",
  },
  {
    year: "The Awakening",
    title: "A Gift Becomes a Calling",
    text: "What began as a childhood mystery matured into mastery. Susan devoted herself to formal study — mediumship, counseling, hypnotherapy, Reiki, and the metaphysical arts — building a rare bridge between the clinical and the spiritual.",
  },
  {
    year: "Unimaginable Loss",
    title: "Grief Becomes Mission",
    text: "After losing both of her brothers and her mother to suicide, along with several friends, Susan transformed her own heartbreak into a lifelong mission: helping others survive the unsurvivable and proving that pain never has to become identity.",
  },
  {
    year: "Three Decades",
    title: "The Practice",
    text: "Nearly 60,000 clients. A Doctorate of Divinity completed under Dr. Raymond Moody — the founder of near-death experience research. Reiki Master, certified addiction and grief specialist, licensed hypnotherapist. A practice built on evidence, empathy, and results.",
  },
  {
    year: "2024",
    title: "International Bestseller",
    text: "Infinite Life, Infinite Lessons debuts worldwide with Hay House — over 10,000 copies sold, foreign editions in Turkey and Spain, and sold-out signings from Los Angeles to Toronto.",
  },
  {
    year: "2026",
    title: "The World Stage",
    text: "The Drew Barrymore Show with Valerie Bertinelli. A sold-out Spirit Encounter at the Omega Institute in Rhinebeck, New York. Esalen ahead. And her own syndicated television talk show in production with Spark TV / Howie Mandel's Studios.",
  },
  {
    year: "2027",
    title: "When Shadows Speak",
    text: "Her highly anticipated second book arrives — with a foreword written by Valerie Bertinelli — introducing a groundbreaking framework for shadow work, grief, and trauma.",
  },
];

export default function Journey() {
  return (
    <section id="journey" data-testid="journey-section" className="relative overflow-hidden py-28 lg:py-40">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -left-8 top-1/3 select-none font-display text-[16rem] font-light italic leading-none text-[#C5A059]/10"
      >
        ∞
      </span>

      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-body text-[0.65rem] font-medium uppercase tracking-[0.5em] text-[#C5A059]"
        >
          The Journey
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.76, 0, 0.24, 1] }}
          className="mt-6 font-display text-4xl font-light leading-tight tracking-tighter text-[#6B5D4F] sm:text-5xl lg:text-6xl"
        >
          A Life Written <span className="italic text-[#C5A059]">in Light</span>
        </motion.h2>

        <div className="relative mt-20">
          <div className="absolute bottom-0 left-4 top-0 w-px bg-[#C5A059]/40" aria-hidden="true" />
          {MILESTONES.map((m, i) => (
            <motion.div
              key={m.title}
              data-testid={`journey-milestone-${i}`}
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: 0.05 * i, ease: [0.76, 0, 0.24, 1] }}
              className="group relative pb-16 pl-14 last:pb-0 md:pl-20"
            >
              <span
                className="absolute left-4 top-2 h-3 w-3 -translate-x-1/2 rotate-45 border border-[#C5A059] bg-[#FDFAF4] transition-colors duration-500 group-hover:bg-[#C5A059]"
                aria-hidden="true"
              />
              <p className="font-script text-2xl text-[#C5A059] md:text-3xl">{m.year}</p>
              <h3 className="mt-2 font-display text-3xl font-light tracking-tight text-[#6B5D4F] md:text-4xl">
                {m.title}
              </h3>
              <p className="mt-4 max-w-2xl font-body text-base font-light leading-relaxed text-[#8B7D6B]">
                {m.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
